<template>
  <f7-page id="page-otp" name="page-otp" @page:afterin="afterin" @page:afterout="afterout">
      <f7-navbar class="view-mobile no-border">
          <f7-nav-left class="back-button">
              <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
          </f7-nav-left>
          <f7-nav-right></f7-nav-right>
      </f7-navbar>

      <f7-block>

        <f7-row>
          <div class="b fs-24 mb-md">{{ $t('label-otp-code') }}</div>
          <div class="fs-14 fw-medium mb-xl text-color-gray">
            {{$t('otp-verification-text')}}<br>{{ mobileNo }}.
          </div>
        </f7-row>

        <f7-row>
          <f7-col>
          <transition name="fade">
            <f7-card
                class   ="alert alert-danger mb-md"
                v-show  ="alertCard.show"
            >
                <f7-card-header>
                  <span v-html="alertCard.title"></span>
                </f7-card-header>
                <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
            </f7-card>
          </transition>
          </f7-col>
        </f7-row>

        <div class="d-flex align-items-center">
          <div class=" b fs-18">{{prefix}}</div>
          <div class="text-align-center mr-sm ml-sm">-</div>
          <!-- <input maxlength="6" /> -->
          <div v-if="this.$f7.device.desktop">
            <div class="d-flex" style="flex-direction: row;">
              <v-otp-input
                ref="otpInput"
                input-classes="otp-input"
                auto-complete="one-time-code"
                separator=""
                :num-inputs="6"
                :should-auto-focus="true"
                :is-input-num="true"
                @on-change="handleOnChange"
                @on-complete="handleOnComplete"
              />
            </div>
          </div>
          <div v-else class="d-flex w-100" style="position: relative;">
            <input
                autocomplete = "one-time-code"
                class        = "otp-input otp-input-single"
                max          = "999999"
                maxlength    = "6"
                min          = "0"
                pattern      = "[0-9]*"
                type         = "tel"
                ref          = "otpInputSingle"
                @input       = "$event=>{this.otpCode=$event.target.value}"
                :style       = "{paddingLeft: otpSingle.leftPadding, letterSpacing: otpSingle.letterSpacing}"
                autofocus
            />
            <div class="w-100" style="position: absolute; z-index: -1; height: 100%; display: flex;">
              <div v-for="i in 6" :key="i" class="otp-blocks"></div>
            </div>
          </div>
        </div>

        <div class="pt-md">
          <div v-show="resendModule.showTimer" class="fs-14 fw-medium text-color-gray">{{$t('otp-resend-text', {timer:resendModule.timerTime})}}</div>
          <div v-show="!resendModule.enableResendLink">
            <span class="fs-14 fw-medium text-color-gray mr-sm">{{$t('otp-didnt-receive-otp-text')}}</span>
            <a @click="resendOTP" class="fs-14 b">{{$t('otp-resend-otp-text')}}</a>
          </div>
        </div>

      </f7-block>
  </f7-page>
</template>

<style>
  #page-otp .otp-blocks {
    width: calc(100% / 6);
    background-color: var(--f7-color-white);
    border: 1px solid rgba(0, 0, 0, 0.3);
    margin: 0 1px;
    border-radius: 8px;
  }
  #page-otp .otp-input {
    border-radius: 8px !important;
    border: 1px solid rgba(0, 0, 0, 0.3) !important;
    font-size: 20px;
    height: 59px;
    margin: 0 1px !important;
    padding: 5px;
    text-align: center;
    width: 100%;
  }
  #page-otp .otp-input-single {
    background-color: transparent;
    border: none !important;
    text-align: left;
    font-family: 'Courier New', Courier, monospace;
  }
  #page-otp .otp-input::-webkit-inner-spin-button,
  #page-otp .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
</style>

<script>
  import Vue from 'vue';
  import OtpInput from "@bachdgvn/vue-otp-input";
  import { mapGetters, mapActions } from "vuex";
  import ApiService from '../services/api-main';
  import store from '../store';

  Vue.component("v-otp-input", OtpInput);

  export default {
    mounted (){
      this.isAxsrTemp = this.isAxsr

      if(window.Android || window.webkit) {
        this.checkBiometryAvaibility();
        this.$root.$once("handleBiometryType", (type) => {
          // 0 = None, 1 = Fingerprint, 2 = Face ID
          this.biometryType = type;
        });
      }
      this.bodyLoad();
    },
    data() {
      return {
        prefix                : "",
        idd                   : "",
        mobileNo              : "",
        otp                   : "",
        otpCode               : "",
        biometryType          : 0,
        isFormValid           : false,
        routerTo              : "",
        isOTPValid            : false,
        otpErrMsg             : "",
        resendModule: {
          timerTime           : 30,
          showTimer           : false,
          enableResendLink    : false
        },
        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },
        otpSingle: {
          width: 0,
          leftPadding: 0,
          letterSpacing: 'unset'
        },
        isAxsrTemp  : false
      };
    },
    updated(){
      if(!this.$f7.device.desktop) {
        this.otpSingle.width = this.$refs.otpInputSingle.clientWidth
      }
    },
    watch: {
      otpCode(value){
        if(value.length >= 6){
          if(!this.$f7.device.desktop) {
            this.$refs.otpInputSingle.setSelectionRange(0, 0);
            this.$refs.otpInputSingle.disabled = true;
          }
          this.navigate();
        }
      },
      'otpSingle.width'(value){
        // (((1/6 of textbox width - x margin) / half ) - average text width)
        let leftPad = (((value / 6) - 2) / 2) - 5
        this.otpSingle.leftPadding = Math.round(leftPad)+"px"
        this.otpSingle.letterSpacing = (leftPad * 2)+"px"
      }
    },
    methods: {
      ...mapActions('auth', ['validateLoginOtp', 'logout']),
      ...mapActions('registration', ['registerNew3', 'resetRegistrationState','setIsAxsr',]),
      ...mapActions('customer', ['updateCustomerMobileNumber','setTempUpdateAccountToken','setTempUpdateAccountType', 'setTempUpdateAccountData']),
      ...mapActions('otp', ['requestotp']),
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      afterout() {
          if(this.$f7.device.desktop && this.routerTo == 'editMobilePhone' && this.$f7router.url == '/account/edit-details') {
              this.setTempUpdateAccountType(this.tempUpdateAccountType)
              this.setTempUpdateAccountData(this.tempUpdateAccountData)
              this.backButton();
          }
      },
      handleOnComplete(value) {
        this.otpCode = value
      },
      handleOnChange(value) {
        console.log('OTP changed: ', value);
      },
      handleClearInput() {
        if(this.$f7.device.desktop) {
          this.$refs.otpInput.clearInput();
        } else {
          this.$refs.otpInputSingle.disabled = false;
          this.$refs.otpInputSingle.value = "";
          this.$refs.otpInputSingle.focus();
        }
      },
      async bodyLoad(){
        this.showPreloader();
        this.routerTo = store.state.misc.otp.routerTo;
        if(store.state.misc.otp.routerTo.trim() == ""){
          await this.logout()
          if(!this.authenticationSuccess && !this.loggedIn){
            this.$f7router.navigate("/login", { transition: 'f7-fade' });
            this.hidePreloader();
          }
        }else{
          if(store.state.misc.otp.routerTo == "loginSuccess"){
            this.mobileNo   = ApiService.getFormData("otpMobilePhone");
            const idd       = ApiService.getFormData("otpIDD");
            const sliceLen  = idd.length;

            // remove first #sliceLen chars
            const newMobileNo = this.mobileNo.slice(sliceLen)

            this.mobileNo = idd+" "+newMobileNo.replace(/.(?=....)/g, '*');
            this.prefix   = ApiService.getFormData("prefix");
          }else if(store.state.misc.otp.routerTo == "registerTnc"){
            var registrationData = store.state.registration;
            this.mobileNo = this.mobileCountryIdd+" "+registrationData.mobileNum.replace(/.(?=....)/g, '*');
            this.prefix = ApiService.getFormData("prefix");
          } else if(store.state.misc.otp.routerTo == "editMobilePhone") {
            this.mobileNo   = ApiService.getFormData("otpMobilePhone");
            const idd       = ApiService.getFormData("otpIDD");
            const sliceLen  = idd.length;

            // remove first #sliceLen chars
            const newMobileNo = this.mobileNo.slice(sliceLen)

            this.mobileNo = idd+" "+newMobileNo.replace(/.(?=....)/g, '*');
            this.prefix   = ApiService.getFormData("prefix");
          }else if(store.state.misc.otp.routerTo == "modifyTransaction") {
            this.mobileNo   = ApiService.getFormData("otpMobilePhone");
            const idd       = ApiService.getFormData("otpIDD");
            const sliceLen  = idd.length;

            // remove first #sliceLen chars
            const newMobileNo = this.mobileNo.slice(sliceLen)

            this.mobileNo = idd+" "+newMobileNo.replace(/.(?=....)/g, '*');
            this.prefix   = ApiService.getFormData("prefix");
          }else if(store.state.misc.otp.routerTo == "resetPasswordComplete") {
            this.mobileNo   = ApiService.getFormData("otpMobilePhone");
            const idd       = ApiService.getFormData("otpIDD");
            const sliceLen  = idd.length;

            // remove first #sliceLen chars
            const newMobileNo = this.mobileNo.slice(sliceLen)

            this.mobileNo = idd+" "+newMobileNo.replace(/.(?=....)/g, '*');
            this.prefix   = ApiService.getFormData("prefix");
          }

          this.countDownTimer();
          this.hidePreloader();
        }
      },
      onFocus(inputIndex){
        document.getElementById("otp"+inputIndex).select();
      },
      countDownTimer() {
        if(this.resendModule.timerTime > 0) {
          this.resendModule.showTimer        = true
          this.resendModule.enableResendLink = true
          setTimeout(() => {
            this.resendModule.timerTime -= 1
            this.countDownTimer()
          },1000)
        }else{
          this.resendModule.timerTime        = 30
          this.resendModule.showTimer        = false
          this.resendModule.enableResendLink = false
        }
      },
      navigate() {
        switch(this.routerTo) {
          case "registerTnc"            : this.validateRegisterOtp(); break;
          case "loginSuccess"           : this.validateOTPLogin(); break;
          case "editMobilePhone"        : this.updateMobileNumber(); break;
          case "modifyTransaction"      : this.modifyTransaction(); break;
          case "resetPasswordComplete"  : this.updateForgotPassword(); break;
        }
      },

      async validateRegisterOtp(){
        this.showPreloader();
        const result = await this.$api.registration.registerNew3(this.otpCode);

        if(!result){
          if(this.authenticationErrorCode == '90014'){
            this.otpErrMsg = this.$t('otp-invalid-text')
          }else if(this.authenticationErrorCode == '90011'){
            this.otpErrMsg = this.$t('otp-invalid-text-11')
          }else{
            this.otpErrMsg = this.$t('otp-invalid-text')
          }

          this.showAlert(true, this.otpErrMsg);
          this.handleClearInput();
          this.hidePreloader();
        }else{
          this.otpErrMsg = "";
          if(result.status == "WN00108"){
            //this.$f7router.navigate("/register-tnc");

            // Register Device Token (Push Notification)
            this.registerDeviceTokenCustomer(result.result.p2hCustomerId);
            this.setCustomerUsingBiometry(result.result.p2hCustomerId, 2);

            // ACCEPT TnC
            const acceptTnc = await this.$api.registration.acceptTnc();
            if(acceptTnc.status == "3105"){
              //console.log("isEmailVerified : "+result.result.emailVerified)
              if(result.result.emailVerified == "0"){
                this.$f7router.navigate("/register-verify-email");
              }else if(this.biometryType != 0){ // redirect to Biometry if email already verified and device support biometry
                this.$f7router.navigate("/register-activate-biometry", { props: { biometryType: this.biometryType }});
              }else{ // redirect to homepage if email already verified
                this.$f7router.navigate("/home");
              }

              this.resetRegistrationState()
              this.setIsAxsr(this.isAxsrTemp)
            }

            this.hidePreloader();
          }else if(result.status == "WN00109"){
            this.otpErrMsg = this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK})
            this.showAlert(true, this.otpErrMsg);
            this.handleClearInput();
            this.hidePreloader();
          }else{
            this.otpErrMsg = result.status;
            console.log("VALIDATE REGISTER OTP ERROR! Status : "+result.status);
            this.showAlert(true, this.otpErrMsg);
            this.handleClearInput();
            this.hidePreloader();
          }
        }

      },
      async validateOTPLogin(){
        this.showPreloader();

        var loginData = store.state.misc;
        ApiService.saveFormData("otp",this.otpCode)
        const result = await this.validateLoginOtp({email: loginData.email, password:loginData.password});

        if(!result){
          if(this.authenticationErrorCode == '90014'){
            this.otpErrMsg = this.$t('otp-invalid-text')
          }else if(this.authenticationErrorCode == '90011'){
            this.otpErrMsg = this.$t('otp-invalid-text-11')
          }else{
            this.otpErrMsg = this.$t('otp-invalid-text')
          }

          this.showAlert(true, this.otpErrMsg);
          this.handleClearInput();
          this.hidePreloader();
        }else{
          this.otpErrMsg = "";
          if(result.data.status == "0100"){ // success
            // Register Device Token (Push Notification)
            this.registerDeviceTokenCustomer(result.data.result.p2hCustomerId);
            this.setCustomerUsingBiometry(result.data.result.p2hCustomerId, 2);

            this.$f7router.navigate("/home", { transition: 'f7-fade', clearPreviousHistory  : true });
            this.hidePreloader();
          } else if(result.data.status == "WN00115"){ // exceeded login attemps
            this.$f7router.navigate("/login?ls=exceeded");
            this.handleClearInput();
            this.hidePreloader();
          }else if(result.data.status == "WN00139"){ // account password has not been set
            this.otpErrMsg = this.$t('reset-password-no-password')
            this.showAlert(true, this.otpErrMsg);
            this.handleClearInput();
            this.hidePreloader();
          }else{
            console.log("VALIDATE LOGIN OTP ERROR!");
            console.log("function validateLoginOtp() => errorCode : "+this.authenticationErrorCode);
            this.otpErrMsg = result.data.message;
            this.showAlert(true, this.otpErrMsg);
            this.handleClearInput();
            this.hidePreloader();
          }
        }

      },
      async updateMobileNumber() {
        try {
          this.showPreloader();
          ApiService.saveFormData("otp",this.otpCode);
          const result = await this.$api.customer.updateCustomerMobileNumber();
          this.handleClearInput();
          this.hidePreloader();

          if(!result){
            if(this.authenticationErrorCode == '90014'){
              this.otpErrMsg = this.$t('otp-invalid-text')
            }else if(this.authenticationErrorCode == '90011'){
              this.otpErrMsg = this.$t('otp-invalid-text-11')
            }else{
              this.otpErrMsg = this.$t('otp-invalid-text')
            }

            this.showAlert(true, this.otpErrMsg);
          }else{
            this.otpErrMsg = "";
            //console.log(result.status+" ### "+result.message)
            if(result.status == "3132" ){ //success
              this.setTempUpdateAccountToken("")
              this.$f7router.navigate("/account/my-details", { props: { isFromUpdateMobile: true }, ignoreCache : true, clearPreviousHistory  : true });

            }else if(result.status == "50002"){
              this.$f7.dialog.alert(this.$t('alert-pin-incorrect'));

            }else{
              this.$f7.dialog.alert(result.message);
            }
          }

        } catch(e){
          this.handleClearInput();
          this.hidePreloader();
          if(e.message.toLowerCase().includes("undefined")) {
              this.$f7.dialog.alert(this.$t('label-error-page-description', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
          } else {
              this.$f7.dialog.alert(e.message);
          }
        }
      },

      async modifyTransaction() {
        this.showPreloader();
        const transactionData = store.state.transaction;

        ApiService.saveFormData("otp",this.otpCode)

        const result = await this.$api.transaction.modifyTransaction(transactionData);
        this.handleClearInput();
        console.log("RESULT",result);

        if(!result){
          if(this.authenticationErrorCode == '90014'){
            this.otpErrMsg = this.$t('otp-invalid-text')
          }else if(this.authenticationErrorCode == '90011'){
            this.otpErrMsg = this.$t('otp-invalid-text-11')
          }else{
            this.otpErrMsg = this.$t('otp-invalid-text')
          }

          this.showAlert(true, this.otpErrMsg);
          this.hidePreloader();
        }else{
          this.otpErrMsg = "";
          if(result.status == "WN00135"){ // success
            transactionData.routerTo = "/transaction-history"
            this.$f7router.navigate("/transaction-history-details", { props: { isTrxModified: true }});
            this.hidePreloader();
          }else{
            console.log("VALIDATE MODIFY TRX ERROR!");
            console.log("function validateLoginOtp() => errorCode : "+this.authenticationErrorCode);
            this.otpErrMsg = result.message;
            this.showAlert(true, this.otpErrMsg);
            this.hidePreloader();
          }
        }

      },

      async updateForgotPassword() {
        this.showPreloader();
        ApiService.saveFormData("otp",this.otpCode)

        const result = await this.$api.customer.updateForgotPassword();
        this.handleClearInput();
        console.log("updateForgotPassword: ", result);

        if(!result){
          if(this.authenticationErrorCode == '90014'){
            this.otpErrMsg = this.$t('otp-invalid-text')
          }else if(this.authenticationErrorCode == '90011'){
            this.otpErrMsg = this.$t('otp-invalid-text-11')
          }else{
            this.otpErrMsg = this.$t('otp-invalid-text')
          }

          this.showAlert(true, this.otpErrMsg);
          this.hidePreloader();
        }else{
          this.otpErrMsg = "";
          if(result.status == "WN00130"){ // success
            this.$f7router.navigate("/reset-password-complete");
            this.hidePreloader();
          } else if(result.status == "WN00131"){ // failed
            this.$f7.dialog.alert(result.message);
            this.$f7router.back({ transition: 'f7-push' });
            this.hidePreloader();
          }else if(result.status == "0107"){ // exceeded reset password attemps
            this.$f7.dialog.alert(this.$t('reset-password-max-attempt', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
            this.hidePreloader();
          }else if(result.status == "0107"){ // cust not found
            this.$f7.dialog.alert(this.$t('reset-password-email-not-found'));
            this.hidePreloader();
          }else{
            console.log("VALIDATE RESET PASSWORD ERROR!");
            this.$f7.dialog.alert(result.message);
            this.hidePreloader();
          }
        }

      },

      async resendOTP(){
        const self = this;

        self.showPreloader();
        this.otpErrMsg = "";
        this.showAlert(false, "");
        if(this.routerTo == "loginSuccess"){
          const requestResendOtp    = await this.$api.otp.requestotp(7);
          if(requestResendOtp.status){
            this.prefix = requestResendOtp.data.prefix;
            self.hidePreloader();
          }else{
            this.otpErrMsg = this.$t(requestResendOtp.message);
            this.showAlert(true, this.otpErrMsg);
            console.log("REQUEST RESEND LOGIN OTP ERROR!");
            self.hidePreloader();
          }
        }else if(this.routerTo == "registerTnc"){
          const requestResendOtp    = await this.$api.otp.requestotp(6);
          if(requestResendOtp.status){
            this.prefix = requestResendOtp.data.prefix;
            self.hidePreloader();
          }else{
            this.otpErrMsg = this.$t(requestResendOtp.message);
            this.showAlert(true, this.otpErrMsg);
            console.log("REQUEST RESEND REGISTER OTP ERROR!");
            self.hidePreloader();
          }
        } else if(this.routerTo == "editMobilePhone") {
          const requestResendOtp    = await this.$api.otp.requestotp(4);
          if(requestResendOtp.status){
            this.prefix = requestResendOtp.data.prefix;
            self.hidePreloader();
          }else{
            this.otpErrMsg = this.$t(requestResendOtp.message);
            this.showAlert(true, this.otpErrMsg);
            console.log("REQUEST RESEND UPDATE MOBILE NUMBER OTP ERROR!");
            self.hidePreloader();
          }
        } else if(this.routerTo == "modifyTransaction") {
          const requestResendOtp    = await this.$api.otp.requestotp(2);
          if(requestResendOtp.status){
            this.prefix = requestResendOtp.data.prefix;
            self.hidePreloader();
          }else{
            this.otpErrMsg = this.$t(requestResendOtp.message);
            this.showAlert(true, this.otpErrMsg);
            console.log("REQUEST RESEND MODIFY TRX OTP ERROR!");
            self.hidePreloader();
          }
        } else if(this.routerTo == "resetPasswordComplete"){
          const requestResendOtp    = await this.$api.otp.requestotp(7);
          if(requestResendOtp.status){
            this.prefix = requestResendOtp.data.prefix;
            self.hidePreloader();
          }else{
            this.otpErrMsg = this.$t(requestResendOtp.message);
            this.showAlert(true, this.otpErrMsg);
            console.log("REQUEST RESEND RESET PASSWORD OTP ERROR!");
            self.hidePreloader();
          }
        }

        /* reset OTP value */
        this.handleClearInput()
        // for(var k = 1; k<=6; k++){
        //   this.otp[k] = "";
        //   let $$ = this.Dom7;
        //   $$("#otp"+k).val(null);
        // }

        this.resendModule.timerTime = 30;
        this.resendModule.showTimer = true;
        this.resendModule.enableResendLink = true;

        this.countDownTimer();
      },
      showAlert(status, title, content){
        this.alertCard.show = status;
        if (title == undefined){
          title = "";
        }
        if (content == undefined){
          content = "";
        }
        this.alertCard.title= title;
        this.alertCard.content = content;

      },
      backButton() {
          switch(this.routerTo) {
              case "loginSuccess"      : this.$f7router.navigate("/login"); break;
              case "registerTnc"       : this.$f7router.navigate("/register-mobile-no"); break;
              case "editMobilePhone"   : this.$f7router.navigate("/account/edit-details", {
                                            force: true
                                          }); break;
              case "modifyTransaction" : this.$f7router.back({ transition: 'f7-push' }); break;
              default                  : this.$f7router.navigate("/"); break;
          }
      },
    },
    components: {

    },
    computed: {
      ...mapGetters('auth', [
            'authenticating',
            'authenticationError',
            'authenticationErrorCode',
            'authenticationSuccess',
            'loggedIn'
        ]),

      ...mapGetters('registration', [
          'mobileCountryId',
          'mobileCountryIdd',
          'isAxsr',
        ]),

      ...mapGetters('customer', [
            'tempUpdateAccountType',
            'tempUpdateAccountData'
        ]),
    },
  }
</script>